/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Summary_GenericInputs */

const cs_audit_summary_generic = /** @type {(inputs: Audit_Summary_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Událost v systému`)
};

const en_audit_summary_generic = /** @type {(inputs: Audit_Summary_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System event`)
};

/**
* | output |
* | --- |
* | "System event" |
*
* @param {Audit_Summary_GenericInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_summary_generic = /** @type {((inputs?: Audit_Summary_GenericInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Summary_GenericInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_summary_generic(inputs)
	return cs_audit_summary_generic(inputs)
});